import React, { useEffect, useMemo, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { fetchAdmins } from "@admin/services/adminApi";

export const ALL_ADMINS = "__all__";

// Admin account filter — rendered only for manage_admins. `value` is a user_id, ALL_ADMINS, or "me".
export function AdminPicker({ value, onChange, testid, meId, allowAll = true }) {
  const [admins, setAdmins] = useState([]);
  useEffect(() => {
    fetchAdmins().then((d) => setAdmins(d.items || [])).catch(() => setAdmins([]));
  }, []);
  // Other admins, de-duplicated by user_id (the API can return one row per role).
  const others = useMemo(() => {
    const seen = new Set();
    return admins.filter((a) => a.user_id && a.user_id !== meId && !seen.has(a.user_id) && seen.add(a.user_id));
  }, [admins, meId]);
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[230px] h-9 text-xs" data-testid={testid}><SelectValue placeholder="Admin" /></SelectTrigger>
      <SelectContent>
        {allowAll && <SelectItem value={ALL_ADMINS} data-testid={`${testid}-all`}>All admins</SelectItem>}
        <SelectItem value="me" data-testid={`${testid}-me`}>Me only</SelectItem>
        {others.map((a) => (
          <SelectItem key={a.user_id} value={a.user_id} data-testid={`${testid}-${a.user_id}`}>
            {a.name || a.email}{a.name ? ` · ${a.email}` : ""}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export function adminParam(value, meId) {
  if (value === ALL_ADMINS) return undefined;
  if (value === "me") return meId;
  return value;
}
